import type { TripAddTripLegWritable } from '@bambi/api-client/schemas';

import type { AddTripFormValues } from '../FormValues';
import {
  buildExistingTripPayload,
  buildNewTripPayload,
} from './adaptFormValuesHelpers';

export function adaptFormValuesToAddTripLeg(
  formValues: AddTripFormValues
): TripAddTripLegWritable {
  const originalTrip: TripAddTripLegWritable['original_trip'] =
    buildExistingTripPayload(formValues.trips[0], formValues);

  const returnTrip: TripAddTripLegWritable['return_trip'] = buildNewTripPayload(
    formValues.trips[1],
    formValues
  );

  return {
    original_trip: originalTrip,
    return_trip: returnTrip,
  };
}
